export { SlideFooter } from "#slide-footer";
export { SlideLessonContinueButton } from "#slide-lesson-continue-button";
